import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
// @ts-nocheck

import { _get as cookieGet, _set as cookieSet, _remove as cookieRemove } from "./cookie";
var cookiesPrefix = '_INTL_TRACKER_COOKIE_';
var TemporaryStorage = /*#__PURE__*/function () {
  function TemporaryStorage() {
    _classCallCheck(this, TemporaryStorage);
  }
  _createClass(TemporaryStorage, [{
    key: "set",
    value:
    /**
     * 设置临时 Cookies
     * 额外支持 set('key', 'value')
     * @param {object} object Object to set;
     */
    function set() {
      var args = [].slice.call(arguments);
      if (args.length >= 2) {
        this._set(_defineProperty({}, args[0], args[1]), args[2] || {});
      } else {
        this._set(args);
      }
    }

    /**
     * 获取临时 Cookies
     * @param {boolean} destroyAfterRead 获取后销毁
     */
  }, {
    key: "get",
    value: function get(key) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var destroyAfterRead = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var keyWithPrefix = "".concat(cookiesPrefix, "_").concat(key);
      var res = cookieGet(keyWithPrefix, opt);
      if (destroyAfterRead) {
        cookieRemove(keyWithPrefix);
      }
      return res;
    }
  }, {
    key: "_set",
    value: function _set(obj) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!obj || Object.keys(obj).length === 0) {
        return;
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var keyWithPrefix = "".concat(cookiesPrefix, "_").concat(key);
          cookieSet(keyWithPrefix, obj[key], opt);
        }
      }
    }
  }]);
  return TemporaryStorage;
}();
export default new TemporaryStorage();